<template>
    <div v-if="isLoading" class="col-12">
        <!-- begin loader -->
        <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
        <!-- end loader -->
    </div>
    <form v-else class="row" @submit.prevent="submitTransactions">
        <div class="col-md-12 text-center">
            <errors v-if="errors_msg?.message">
                {{ errors_msg.message }}
            </errors>
        </div>
        <form-transaction :form="form" :add_or_edit="true" :coa_subhead_options="coa_subhead_options"
            :model_options="model_options" :trans_type="trans_type"></form-transaction>
        <hr class="mt-1" />
        <div class="col-12 text-end">
            <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size  me-3">
                <span class="small">
                    <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Save
                </span>
            </button>
        </div>
    </form>
</template>
<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import FormTransaction from "./FormTransaction.vue";
export default {
    components: {
        Multiselect,
        FormTransaction
    },
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            coa_subhead: {},
            isSaving: false,
            form: {
                transaction_id: "",
                model_id: "",
                model_type: [],
                cr_amount: "",
                dr_amount: "",
                coa_subhead_id: "",
                transaction_description: "",
                branch_id: "",
                note: "",
                transaction_date: "",
            },
            model_options: [
                { 'id': "App\\Models\\Transaction", "name": 'Transactions' },
                { 'id': "App\\Models\\Journal", "name": 'Journals' },
                { 'id': "App\\Models\\Voucher", "name": 'Vouchers' },
                { 'id': "App\\Models\\LoanProductScheme", "name": 'Loans' },
                { 'id': "App\\Models\\FixedDepositProductScheme", "name": 'Fixed Deposits' },
                { 'id': "App\\Models\\COASubHead", "name": 'COA Subhead' },
            ]
        }
    },
    props: {
        coa_data: {
            required: true
        },
        coa_subhead_options: {
            required: true
        },
        trans_type: {
            required: true
        }
    },
    mounted() {
        if (this.coa_subhead_options.length > 0) {
            // Find the matching model option
            const modelOption = this.model_options.find(option =>
                option.id == this.coa_data?.model_type ?? ""
            );


            // Find the form 
            this.form = {
                model_id: this.coa_data?.model_id ?? "",
                cr_amount: this.coa_data?.cr_amount ?? "",
                dr_amount: this.coa_data?.dr_amount ?? "",
                model_type: modelOption || [],
                transaction_description: this.coa_data?.transaction_description ?? "",
                transaction_date: this.coa_data?.transaction_date
            };

        }
    },
    methods: {
        submitTransactions() {
            this.isSaving = true
            // console.log(this.form.model_id);
            var notes = ""
            if (this.form.cr_amount > 0) {
                notes = 'RECEIPT_ENTRY'
            } else {
                notes = 'PAYMENT_ENTRY'
            }
            let form = this.form = {
                'transaction_id': this.coa_data?.id ?? this.form?.model_id,
                'model_id': this.form.model_id,
                'model_type': this.form.model_type.id,
                'cr_amount': this.form.cr_amount,
                'dr_amount': this.form.dr_amount,
                'coa_subhead_id': this.form?.coa_subhead_id?.id,
                'transaction_description': this.form?.transaction_description,
                'branch_id': this.form?.coa_subhead_id?.coabranch?.id,
                'note': this.coa_data?.note ?? notes,
                'transaction_date': this.form.transaction_date
            }
            ApiService.post("/finance/coa-transaction/store", form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.errors_msg = {};
                    this.$emit('savedAdd')
                    // this.form = this.initialState().form;
                })
                .catch((error) => {
                    // console.log(error.response.data.message);
                    this.isSaving = false;
                    this.$Progress.fail();
                    this.save = "Save";
                    if (error.response.data) {
                        // Clear previous errors
                        this.errors_msg = {};
                        // Set general message
                        this.errors_msg.message = error.response.data.message;
                        // Set field-specific errors if they exist
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                this.errors_msg[key] = error.response.data.errors[key];
                            });
                        }
                    }
                });
        },
    }

}
</script>